import type { ISceneItemDetailsFactory, IViewFactory, IViewFactoryProvider, JSONConfig } from './interfaces';
import { ViewFactory } from './View.factory';
import { TYPES } from '@/engine/ioc/types';
import { inject, injectable } from 'inversify';

@injectable()
export class ViewFactoryProvider implements IViewFactoryProvider<JSONConfig.Config> {
  private readonly _detailsFactory: ISceneItemDetailsFactory;

  public constructor(
    @inject(TYPES.ISceneItemDetailsFactory)
    detailsFactory: ISceneItemDetailsFactory
  ) {
    this._detailsFactory = detailsFactory;
  }

  public makeFactory(config: JSONConfig.Config): IViewFactory {
    return new ViewFactory(config, this._detailsFactory);
  }
}
